













import {
  Vue,
  Component,
} from 'vue-property-decorator';
import Versioning from '@/components/Versioning.vue';
import { version } from '../../package.json';

/**
 * This component is showing the content of the home page view
 * It displays a link to the profile test and the version of the app
 */
@Component({
  components: {
    Versioning,
  },
})
export default class Welcome extends Vue {
  private version = version;
}
